import { UserLock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

/**
 * Stands in for a cost figure that belongs to a named Resource (their Internal Rate,
 * 2026-10-14). Shown to readers without viewResourceInternalRates, whose payload carries
 * no figure at all — the server withheld it, this only says why the cell is empty.
 */
export function InternalRateChip() {
  return (
    <Badge
      variant="outline"
      className="gap-1 font-normal text-muted-foreground"
      title="Priced at this Resource's own Internal Rate. Only Admin, Finance and Resource Managers can see the figure."
    >
      <UserLock className="size-3" aria-hidden />
      Internal Rate
    </Badge>
  );
}
